import { Box } from "@mui/material";
import { boxStyle } from "../../../constants";

const CodeRewardList = () => {
  return <Box sx={boxStyle}></Box>;
};

export default CodeRewardList;
